import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../axiosInterceptor';

export type SupportTicketPayload = {
  category: string;
  message: string;
};

type SupportTicketState = {
  loading: boolean;
  error: boolean;
  errorMessage: string;
  data: unknown | null;
};

const initialState: SupportTicketState = {
  loading: false,
  error: false,
  errorMessage: '',
  data: null,
};

export const createSupportTicket = createAsyncThunk<unknown, SupportTicketPayload>(
  'supportTicket/create',
  async ({ category, message }) => {
    if (!category.trim() || !message.trim()) {
      throw new Error('Missing support ticket details.');
    }
    const { data } = await api.post('/api/support/tickets', {
      category,
      message,
    });
    return data;
  }
);

const supportTicketSlice = createSlice({
  name: 'supportTicket',
  initialState,
  reducers: {
    resetSupportTicket: (state) => {
      state.loading = false;
      state.error = false;
      state.errorMessage = '';
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createSupportTicket.pending, (state) => {
      state.loading = true;
      state.error = false;
      state.errorMessage = '';
    });
    builder.addCase(createSupportTicket.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    });
    builder.addCase(createSupportTicket.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.errorMessage =
        action.error.message ?? 'Failed to submit support ticket.';
    });
  },
});

export const { resetSupportTicket } = supportTicketSlice.actions;
export default supportTicketSlice.reducer;
